<a (click)='onClick()'>
    <i class='font-icon icon-arrow-left'></i>
    <span>
        {{ strings['carLeasingDetails.backLink.text'] }}
    </span>
</a>